import { observer } from "mobx-react";
import "./index.css";
import { RadioButton } from "../RadioButton";
import { TextArea } from "../TextArea";
import strings from "../../localization";
import { IssueSolvedList } from "../../helpers/statics";
import CallStore from "../../stores/CallStore";

const CallSelectIssue = () => {

  const sparePart = CallStore.call?.sparePart ? CallStore.call.sparePart : '';

  const issue = CallStore.call?.result ? CallStore.call.result : null;

  const setSparePart = (value) => {
    CallStore.setCall({ ...CallStore.call, sparePart: value });
  }

  const setSelectedIssueSolved = (value) => {
    CallStore.setCall({ ...CallStore.call, result: value });
  }

  return <div className="call-select-issue">
    <span className="call-select-issue-title">{strings.isTheIssueSolved}</span>
    <div className="call-select-issue-container">
      <div className="call-select-issue-left">
        {IssueSolvedList.map((item) => (
          <div key={item.id} className="call-select-issue-left-box"
            onClick={() => setSelectedIssueSolved(item.key)}
          >
            <img src={item.icon} alt={item.title} />
            <div className="call-select-issue-left-box-title">
              <span>{item.title}</span>
              <span>{item.description}</span>
            </div>
            <div className="call-select-issue-left-box-radio">
              <RadioButton
                value={issue === item.key}
              />
            </div>
          </div>
        ))}
      </div>
      <div className="call-select-issue-right">
        <TextArea label={strings.sparePart} placeholder={strings.enterYourNotesHere} value={sparePart} onChange={setSparePart} disabled={issue !== 'spare_part_needed'} />
      </div>
    </div>
  </div>;
};

export default observer(CallSelectIssue);